/**
 * 偵測 useFetch / SWR 拋出的 API 錯誤是否為「無權限」(403)。
 * useFetch 拋出的 error 是後端回的 ApiResponse body：
 *   { success: false, error: { code: 'FORBIDDEN' | 'PERMISSION_DENIED', message: ... } }
 */
export function isForbiddenError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false
  const code = (error as { error?: { code?: string } }).error?.code
  return code === 'FORBIDDEN' || code === 'PERMISSION_DENIED'
}
